import { useGetProfitAndLossReportQuery } from '@/features/slice/report';

export const useProfitAndLossReport = () => {
    const { data, isLoading, isFetching, isError, error } =
        useGetProfitAndLossReportQuery({});

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
    };
};
